import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Logintenagakesehatan from "./Pages/TenagaKesehatan/logintenagakesehatan";
import Loginadmin from "./Pages/Admin/loginadmin";
import Registertenagakesehatan from "./Pages/TenagaKesehatan/registertenagakesehatan";
import WhyChoose from "./components/WhyChoose";
import DashboardTenagaKesehatan from "./Pages/TenagaKesehatan/DashboardTenagaKesehatan";
import SidebarTenagaKesehatan from "./components/SidebarTenagaKesehatan";
import TopBarTenagaKesehatanLaporKendala from "./components/TopBarTenagaKesehatanLaporKendala";
import LaporkanKendalaTenagaKesehatan from "./components/LaporkanKendalaTenagaKesehatan";
import LaporKendalaTenagaKesehatan from "./Pages/TenagaKesehatan/LaporKendalaTenagaKesehatan";
import ProfileTenagaKesehatan from "./components/ProfileTenagaKesehatan";
import DetailTenagaKesehatanProfile from "./Pages/TenagaKesehatan/DetailTenagaKesehatanProfile";
import EditProfileTenagaKesehatan from "./components/EditProfileTenagaKesehatan";
import EditDetailProfileTenagaKesehatan from "./Pages/TenagaKesehatan/EditDetailProfileTenagaKesehatan";
import HalamanAktivitasTenagaKesehatan from "./Pages/TenagaKesehatan/HalamanAktivitasTenagaKesehatan";
import AktivitasTenagaKesehatan from "./components/AktivitasTenagaKesehatan";
import SemuaDataPasienTK from "./components/SemuaDataPasienTK";
import HalamanDataPasienTK from "./Pages/TenagaKesehatan/HalamanDataPasienTK";
import DetailPasienTK from "./components/DetailPasienTK";
import HalamanDetailPasienTK from "./Pages/TenagaKesehatan/HalamanDetailPasienTK";
import HalamanEditDetailPasienTK from "./Pages/TenagaKesehatan/HalamanEditDetailPasienTK";
import EditDetailPasienTK from "./components/EditDetailPasienTK";
import PetaRisiko from "./components/PetaRisiko";
import HalamanPetaRisikoTenagaKesehatan from "./Pages/TenagaKesehatan/HalamanPetaRisikoTenagaKesehatan";
import RingkasanAnalitikTK from "./components/RingkasanAnalitikTK";
import HalamanRingkasanAnalitikTK from "./Pages/TenagaKesehatan/HalamanRingkasanAnalitikTK";
import HalamanPetaRisikoAdmin from "./Pages/Admin/HalamanPetaRisikoAdmin";
import SemuaDataPasienAdmin from "./components/SemuaDataPasienAdmin";
import HalamanDataPasienAdmin from "./Pages/Admin/HalamanDataPasienAdmin";
import HalamanDetailPasienAdmin from "./Pages/Admin/HalamanDetailPasienAdmin";
import DetailPasienAdmin from "./components/DetailPasienAdmin";
import HalamanTenagaKesehatan from "./Pages/Admin/HalamanTenagaKesehatan";
import HalamanDetailTenagaKesehatan from "./Pages/Admin/HalamanDetailTenagaKesehatan";
import SemuaTenagaKesehatan from "./components/SemuaTenagaKesehatan";
import HalamanAktivitasTenagaKesehatanAdmin from "./Pages/Admin/HalamanAktivitasTenagaKesehatanAdmin";
import ProfileTenagaKesehatanAdmin from "./components/ProfileTenagaKesehatanAdmin";
import EditProfileTenagaKesehatanAdmin from "./components/EditProfileTenagaKesehatanAdmin";
import HalamanEditProfileTenagaKesehatan from "./Pages/Admin/HalamanEditProfileTenagaKesehatan";
import AktivitasTenagaKesehatanAdmin from "./components/AktivitasTenagaKesehatanAdmin";
import RingkasanAnalitikAdmin from "./components/RingkasanAnalitikAdmin";
import HalamanRingkasanAnalitikAdmin from "./Pages/Admin/HalamanRingkasanAnalitikAdmin";
import HalamanLaporanKendalaTeknisAdmin from "./Pages/Admin/HalamanLaporanKendalaTeknisAdmin";
import LaporanKendalaTeknisAdmin from "./components/LaporanKendalaTeknisAdmin";
import ChatPasienTK from "./components/ChatPasienTK";
import HalamanMessageTK from "./Pages/TenagaKesehatan/HalamanMessageTK";
import TindakLanjutAdmin from "./components/TindakLanjutAdmin";
import HalamanTindakLanjut from "./Pages/Admin/HalamanTindakLanjut";
import ProfileAdmin from "./components/ProfileAdmin";
import HalamanProfileAdmin from "./Pages/Admin/HalamanProfileAdmin";
import EditProfileAdmin from "./components/EditProfileAdmin";
import HalamanEditProfileAdmin from "./Pages/Admin/HalamanEditProfileAdmin";
import DashboardAdmin from "./Pages/Admin/DashboardAdmin";
import HalamanKelolaFAQsAdmin from "./Pages/Admin/HalamanKelolaFAQsAdmin";
import KelolaFAQs from "./components/KelolaFAQs";
import HalamanDokterParu from "./Pages/Admin/HalamanDokterParu";
import SemuaDokterParu from "./components/SemuaDokterParu";
import HalamanDetailDokterParu from "./Pages/Admin/HalamanDetailDokterParu";
import ProfileDokterParuAdmin from "./components/ProfileDokterParuAdmin";



function App() {
  return (
    <div className="App">
      <Router>
      <Routes>
        <Route path="/Logintenagakesehatan" element={<Logintenagakesehatan />} />
        <Route path="/Loginadmin" element={<Loginadmin />} />
        <Route path="/Registertenagakesehatan" element={<Registertenagakesehatan />} />
        <Route path="/WhyChoose" element={<WhyChoose />} />
        <Route path="/DashboardTenagaKesehatan" element={<DashboardTenagaKesehatan />} />
        <Route path="/" element={<DashboardAdmin />} />
        <Route path="/SidebarTenagaKesehatan" element={<SidebarTenagaKesehatan />} />
        <Route path="/TopBarTenagaKesehatanLaporKendala" element={<TopBarTenagaKesehatanLaporKendala />} />
        <Route path="/LaporkanKendalaTenagaKesehatan" element={<LaporkanKendalaTenagaKesehatan />} />
        <Route path="/LaporKendalaTenagaKesehatan" element={<LaporKendalaTenagaKesehatan />} />
        <Route path="/ProfileTenagaKesehatan" element={<ProfileTenagaKesehatan />} />
        <Route path="/DetailTenagaKesehatanProfile" element={<DetailTenagaKesehatanProfile />} />
        <Route path="/EditDetailProfileTenagaKesehatan" element={<EditDetailProfileTenagaKesehatan/>} />
        <Route path="/EditProfileTenagaKesehatan" element={<EditProfileTenagaKesehatan/>} />
        <Route path="/HalamanAktivitasTenagaKesehatan" element={<HalamanAktivitasTenagaKesehatan/>} />
        <Route path="/AktivitasTenagaKesehatan" element={<AktivitasTenagaKesehatan/>} />
        <Route path="/HalamanDataPasienTK" element={<HalamanDataPasienTK/>} />     
        <Route path="/SemuaDataPasienTK" element={<SemuaDataPasienTK/>} />
        <Route path="/DetailPasienTK" element={<DetailPasienTK/>} />
        <Route path="/HalamanDetailPasienTK/:id" element={<HalamanDetailPasienTK/>} />
        <Route path="/HalamanEditDetailPasienTK" element={<HalamanEditDetailPasienTK/>} />
        <Route path="/EditDetailPasienTK" element={<EditDetailPasienTK/>} />
        <Route path="/PetaRisiko" element={<PetaRisiko/>} />
        <Route path="/HalamanPetaRisikoTenagaKesehatan" element={<HalamanPetaRisikoTenagaKesehatan/>} />
        <Route path="/RingkasanAnalitikTK" element={<RingkasanAnalitikTK/>} />
        <Route path="/HalamanRingkasanAnalitikTK" element={<HalamanRingkasanAnalitikTK/>} />
        <Route path="/HalamanPetaRisikoAdmin" element={<HalamanPetaRisikoAdmin/>} />
        <Route path="/SemuaDataPasienAdmin" element={<SemuaDataPasienAdmin/>} />
        <Route path="/HalamanDataPasienAdmin" element={<HalamanDataPasienAdmin/>} />
        <Route path="/DetailPasienAdmin" element={<DetailPasienAdmin/>} />
        <Route path="/HalamanDetailPasienAdmin/:id" element={<HalamanDetailPasienAdmin/>} />
        <Route path="/HalamanTenagaKesehatan" element={<HalamanTenagaKesehatan/>} />
        <Route path="/SemuaTenagaKesehatan" element={<SemuaTenagaKesehatan/>} />
        <Route path="/HalamanDetailTenagaKesehatan/:id" element={<HalamanDetailTenagaKesehatan/>} />
        <Route path="/HalamanAktivitasTenagaKesehatanAdmin" element={<HalamanAktivitasTenagaKesehatanAdmin/>} />
        <Route path="/ProfileTenagaKesehatanAdmin" element={<ProfileTenagaKesehatanAdmin />} />
        <Route path="/HalamanDetailTenagaKesehatan" element={<HalamanDetailTenagaKesehatan/>} />
        <Route path="/EditProfileTenagaKesehatanAdmin" element={<EditProfileTenagaKesehatanAdmin/>} />
        <Route path="/HalamanEditProfileTenagaKesehatan" element={<HalamanEditProfileTenagaKesehatan/>} />
        <Route path="/AktivitasTenagaKesehatanAdmin" element={<AktivitasTenagaKesehatanAdmin/>} />
        <Route path="/RingkasanAnalitikAdmin" element={<RingkasanAnalitikAdmin/>} />
        <Route path="/HalamanRingkasanAnalitikAdmin" element={<HalamanRingkasanAnalitikAdmin/>} />
        <Route path="/HalamanLaporanKendalaTeknisAdmin" element={<HalamanLaporanKendalaTeknisAdmin/>} />
        <Route path="/LaporanKendalaTeknisAdmin" element={<LaporanKendalaTeknisAdmin/>} />
        <Route path="/ChatPasienTK" element={<ChatPasienTK/>} />
        <Route path="/HalamanMessageTK" element={<HalamanMessageTK/>} />
        <Route path="/TindakLanjutAdmin" element={<TindakLanjutAdmin/>} />
        <Route path="/HalamanTindakLanjut/:id" element={<HalamanTindakLanjut/>} />
        <Route path="/HalamanProfileAdmin" element={<HalamanProfileAdmin/>} />
        <Route path="/ProfileAdmin" element={<ProfileAdmin/>} />
        <Route path="/EditProfileAdmin" element={<EditProfileAdmin/>} />
        <Route path="/HalamanEditProfileAdmin" element={<HalamanEditProfileAdmin/>} />
        <Route path="/HalamanKelolaFAQsAdmin" element={<HalamanKelolaFAQsAdmin/>} />
        <Route path="/KelolaFAQs" element={<KelolaFAQs/>} />
        <Route path="/HalamanDokterParu" element={<HalamanDokterParu/>} />
        <Route path="/HalamanDetailDokterParu/:id" element={<HalamanDetailDokterParu/>} />
        
       
        
      </Routes>
    </Router>
      
    </div>
  );
}

export default App;
